import { Injectable } from '@angular/core';
import { Currency } from 'src/app/shared/models/currency.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ReportsUriService } from './reports-uri.service';
import { Observable } from 'rxjs';
import { CascadeInvoiceItemsReport } from '../models/cascade-invoice-items-report.model';
import { CascadeInvoiceItemsFilters } from '../models/cascade-invoice-items-filters.model';
import { environment } from 'src/environments/environment';
import { ProviderList } from 'src/app/shared/models/provider.model';



@Injectable({
    providedIn: 'root'
})

export class ReportsGatewayService {
    baseUrl = environment.baseUrl;
    
    constructor(private reportsUriService: ReportsUriService, private http: HttpClient) {

    }
    getCurrencies(): Observable<Currency[]> {
        const url = this.reportsUriService.getCurrenciesUri();
        return this.http.get<Currency[]>(url);
    }

    getProviders(filters?: any): Observable<ProviderList> {
        let params = new HttpParams();

        for (let filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        const url = this.reportsUriService.getProvidersUri();
        return this.http.get<ProviderList>(url, { params });
    }

    getCascadeInvoiceItemReport(filters: CascadeInvoiceItemsFilters): Observable<CascadeInvoiceItemsReport[]> {
        let params = new HttpParams();

        for (let filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        const url = this.reportsUriService.getCascadeInvoiceItemReportUri();
        return this.http.get<CascadeInvoiceItemsReport[]>(url, { params });
    }

    getDigitalOrders(filters) {

        let params = new HttpParams();

        for (let filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        const url = this.reportsUriService.getDigitalOrdersUri();
        return this.http.get<CascadeInvoiceItemsReport[]>(url, { params });
    }

    getDigitalOrdersArchive(filters) {

        let params = new HttpParams();

        for (let filter in filters) {
            if (filters[filter]) {
                params = params.append(filter, filters[filter]);
            }
        }

        const url = this.reportsUriService.getDigitalOrdersArchiveUri();
        return this.http.get<CascadeInvoiceItemsReport[]>(url, { params });
    }

    getActivityLogs(filters): Observable<any> {
        let params = new HttpParams();
        for (const filter in filters) {
          if (filters[filter]) {
            params = params.append(filter, filters[filter]);
          }
        }
        return this.http.get<any>(`${this.baseUrl}/activity-logs/user-history/`, { params });
      }

    getRetailerProductList(filters): Observable<any> {
        let params = new HttpParams();
        for (const filter in filters) {
          if (filters[filter]) {
            params = params.append(filter, filters[filter]);
          }
        }

        return this.http.get<any>(`${this.baseUrl}/reports/panel/retailer-products/`, { params });
    }

    exportRetailerProducts(): Observable<Blob> {
        return this.http.get<Blob>(`${this.baseUrl}/reports/panel/retailer-products/export/`, { responseType: 'blob' as 'json'})
    }

    getDebitCreditNoteList(filters): Observable<any> {
        let params = new HttpParams();
        for (const filter in filters) {
          if (filters[filter]) {
            params = params.append(filter, filters[filter]);
          }
        }

        const url = this.reportsUriService.getDebitCreditNoteListUri();
        return this.http.get<any>(url, { params });
    }

    getSalesReportByDate(filters: any): Observable<any> {
        let params = new HttpParams();
        for (const filter in filters) {
          if (filters[filter]) {
            params = params.append(filter, filters[filter]);
          }
        }

        return this.http.get<any>(`${this.baseUrl}/reports/panel/sales-report-by-date/`, { params });
    }
}